import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  TextField
} from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { TraceBoardColumn } from '../interfaces/TraceBoardColumn';
import { TraceBoardItem } from '../interfaces/TraceBoardItem';
import { useTraceBoardContext } from '../TraceBoardContext';

export type TraceBoardAddItemDialogProps = Omit<DialogProps, 'onClose'> & {
  column: TraceBoardColumn;
  columnIndex: number;
  sourceItem?: TraceBoardItem;
  onClose?: () => void;
};

const TraceBoardAddItemDialog: React.FC<TraceBoardAddItemDialogProps> = ({
  column,
  columnIndex,
  sourceItem,
  onClose,
  ...props
}) => {
  const onCloseRef = useRef(onClose);
  const [description, setDescription] = useState('');
  const [isAdding, setIsAdding] = useState(false);
  const { onAddItem, loadingItem, setLoadingItem } = useTraceBoardContext();
  useEffect(() => {
    if (isAdding && !loadingItem) {
      onCloseRef.current?.();
    }
  }, [isAdding, loadingItem]);
  return (
    <Dialog fullWidth {...props}>
      <DialogTitle>Create {column.title}</DialogTitle>
      <DialogContent>
        {sourceItem && (
          <Box mb={2}>
            The new item will be linked to {sourceItem.title}:{' '}
            {sourceItem.description}
          </Box>
        )}
        <TextField
          fullWidth
          autoFocus
          variant='outlined'
          placeholder='Type in a description for the new item'
          value={description}
          onChange={event => setDescription(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose?.()}>Cancel</Button>
        <Button
          variant='contained'
          color='primary'
          endIcon={
            loadingItem && <CircularProgress size={16} color='secondary' />
          }
          onClick={() => {
            const newItem = { id: 'new', description };
            onAddItem?.(newItem, sourceItem, column, columnIndex);
            setLoadingItem(newItem);
            setIsAdding(true);
          }}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TraceBoardAddItemDialog;
